/**
 * What the assistant in the header shows: its dot, and one line for screen readers.
 * Anything waiting on the loan officer in the chat wins, then work in progress, then Autopilot.
 */

/**
 * @param {{
 *   run?: { isRunning?: boolean, waiting?: "approval" | "answer" | "", statusText?: string, isVoice?: boolean },
 *   autopilot?: { text: string, tone: "ready" | "wait" },
 * }} state
 * @returns {{ tone: "ready" | "busy" | "wait", text: string }}
 */
export const getLendyStatus = ({ run = {}, autopilot = { text: "", tone: "ready" } } = {}) => {
  if (run.waiting) {
    return { tone: "wait", text: run.waiting === "approval" ? "Needs your OK" : "Needs your answer" };
  }
  if (run.isRunning) {
    const statusText = (run.statusText || "").trim();
    return { tone: "busy", text: statusText && statusText !== "Thinking…" ? statusText : "Working…" };
  }
  if (run.isVoice) {
    return { tone: "busy", text: "Voice mode" };
  }

  // Idle, only what the loan officer has to act on is worth a line.
  const isWaiting = autopilot.tone === "wait";

  return { tone: isWaiting ? "wait" : "ready", text: isWaiting ? autopilot.text : "" };
};
